Fastweb.Contests = (function($) {
  init = function(ctaButton) {
    $(ctaButton).on('click', function(e) {
      var visitorId = null;
      var mauuid = Fastweb.Contests.getCookieValue('__mauuid');

      try {
        if (typeof _satellite !== 'undefined' && 
            _satellite.getVisitorId && 
            _satellite.getVisitorId().getMarketingCloudVisitorID) {
          visitorId = _satellite.getVisitorId().getMarketingCloudVisitorID();
        }
      } catch (err) {
        console.warn('Visitor ID could not be retrieved: ', err);
      }

      // Only call track if _satellite exists
      if (typeof _satellite !== 'undefined' && _satellite.track) {
        _satellite.track('fastweb form submit');
      }

      $('#ext_idmc').val(visitorId);
      $('#ext_id_net_results').val(mauuid);

      return true;
    });
  }

  getCookieValue = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') { c = c.substring(1, c.length); }
      if (c.indexOf(nameEQ) == 0) { return c.substring(nameEQ.length, c.length); }
    }
    return null;
  }

  return {init: init, getCookieValue: getCookieValue}

})(jQuery);
